import { jsxs as f, jsx as d } from "react/jsx-runtime";
import { forwardRef as x, useContext as I } from "react";
import { MenuContext as N } from "./context.js";
import { c as w, u as C, l as F } from "../../floating-ui.react-K1eW_SJH.js";
import { s as r } from "../../Dropdown.module-CFFK1Ien.js";
import g from "../icon/Icon.js";
import k from "classnames";
const v = x(({ label: s, disabled: i, icon: a, ...e }, u) => {
  const o = I(N), c = w({ label: i ? null : s }), m = C(), l = c.index === o.activeIndex;
  return /* @__PURE__ */ f(
    "button",
    {
      ...e,
      ref: F([c.ref, u]),
      type: "button",
      role: "menuitem",
      className: k(r["dropdown-item"], e.className),
      tabIndex: l ? 0 : -1,
      disabled: i,
      ...o.getItemProps({
        onClick(n) {
          var t;
          (t = e.onClick) == null || t.call(e, n), m == null || m.events.emit("click");
        },
        onFocus(n) {
          var t;
          (t = e.onFocus) == null || t.call(e, n), o.setHasFocusInside(!0);
        }
      }),
      children: [
        !!a && /* @__PURE__ */ d(g, { name: a, className: r.icon }),
        s
      ]
    }
  );
});
v.displayName = "DropdownItem";
export {
  v as default
};
